__turbopack_context__.v({
  "close-icon": "X6F3_W_close-icon",
  "is-fixed": "X6F3_W_is-fixed",
  "splitWarning": "X6F3_W_splitWarning",
  "toast-container": "X6F3_W_toast-container",
  "toast-content": "X6F3_W_toast-content",
  "toast-content-inner": "X6F3_W_toast-content-inner",
  "toast-text": "X6F3_W_toast-text",
});
